import React from 'react';
import formFieldType from '@/forms/helper';
import FormObjectDialog from '@/forms/objects/components/FormObjectDialog';
import { linkFields } from '@/forms/state/state';
import catalogueFieldComponents from '../helper';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const CatalogueLinksDialog = ({ theme }) => {
  const state = selectors.useCatalogueObjectFields();
  const applyChanges = events.useApplyCatalogueObjects(state.category, { code: state.code });
  const changeItem = events.useUpdateActiveCatalogueObject();
  const deleteItem = events.useDeleteActiveCatalogueObject();
  const hide = events.useHideCatalogueObjects();
  const insertItem = events.useInsertCatalogueLink();
  const updateProperties = events.useUpdateCatalogueObjectProperties();
  const updateObjectsProperties = events.useUpdateCatalogueObjectsProperties();

  return (
    <FormObjectDialog
      activeIndex={state.activeIndex}
      allowAdd={state.allowAdd}
      allowRemove={state.allowRemove}
      canEdit
      category={state.category}
      changeItem={changeItem}
      code={state.code}
      component={(f) => catalogueFieldComponents[formFieldType(f)]}
      deleteItem={deleteItem}
      entity="catalogue.link"
      field={state.field}
      fields={state.field ? linkFields(state.field) : []}
      hide={hide}
      insertItem={() => insertItem(state)}
      isDirty={state.isDirty}
      isEditing
      item={state.item}
      items={state.items}
      onSave={() => applyChanges(state)}
      saveErrors={state.saveErrors}
      saveStatus={state.saveStatus}
      textField="text"
      theme={theme}
      updateObjectsProperties={updateObjectsProperties}
      updateProperties={(attributes) => updateProperties({ ...attributes, template: state.template })}
    />
  );
};

export default CatalogueLinksDialog;
